import React, { FC, useEffect, useState } from 'react';
import { CreateButton, useDataProvider, useRedirect } from 'react-admin';
import Button from '@material-ui/core/Button';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { Box, Typography } from '@material-ui/core';
import { getDate } from '../../../helpers/dateHelper';
import DateTimePicker from "react-datetime-picker";
import "./index.css"
import "../../../helpers/css/dateTimePicker.css";
import settings from "../../../helpers/images/settings.svg"

interface State {
    showDialog: boolean;
    all: boolean;
    active: boolean;
    inactive: boolean;
    startDate: Date;
    endDate: Date;
    competitionId: string;
}

interface Props {
    activeFilter: (status: string) => void;
    title: string;
    path: string;
    isPrize: boolean;
    permission: boolean
}

const PrizeListTitle: FC<Props> = ({ activeFilter, title, path, isPrize, permission }) => {
    const dataProvider = useDataProvider()
    const redirect = useRedirect()
    const [state, setState] = useState<State>({
        showDialog: false,
        startDate: new Date(),
        endDate: new Date(),
        all: true,
        active: false,
        inactive: false,
        competitionId: ''
    })

    const [error, setError] = useState({
        endEarly: false,
        endEarlyThanNow: false,
        requiredStart: false,
        requiredEnd: false
    })


    useEffect(() => {
        if (path === "prizes") {
            getManagement()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getManagement = async () => {
        const result = await dataProvider.getOne('competitions', { id: isPrize ? "PRIZE" : "FIXED_ODDS" });
        const startDateResponse = new Date(result.data.startAt)
        const endDateResponse = new Date(result.data.endsAt)
        setState({ ...state, startDate: startDateResponse, endDate: endDateResponse, competitionId: result.data._id })
    }

    const saveCountDown = async () => {
        if (!state.startDate) {
            setError({ ...error, requiredStart: true })
            return
        }
        if (!state.endDate) {
            setError({ ...error, requiredEnd: true })
            return
        }
        const start = new Date(state.startDate).toUTCString()
        const end = new Date(state.endDate).toUTCString()
        const data = { startAt: start, endsAt: end, competition: isPrize ? "PRIZE" : "FIXED_ODDS" }
        const isError = checkDate(state.startDate, state.endDate)
        if (isError) {
            setError({ ...error, endEarly: true })
            return
        }

        if (error.endEarlyThanNow) {
            return
        }
        await dataProvider.update("competitions", {
            data: data,
            id: state.competitionId,
            previousData: {} as any
        });
        closeModal()
    }

    const checkDate = (start: Date, end: Date) => {
        const startDate = start.getTime()
        const endDate = end.getTime()
        if (startDate >= endDate) {
            return true
        }
        return false
    }

    const closeModal = () => {
        setState({ ...state, showDialog: false })
    }

    const showDialog = () => {
        if (permission) {
            setState({ ...state, showDialog: true })
        }
    }

    const setEndDate = (value: Date) => {
        if (!value) {
            setState({ ...state, endDate: value })
            return
        }
        const now = Date.now();
            
        const checkEndDate = value.getTime();
        const isError = checkDate(state.startDate, value);
        let checkEndError = false;
        if (checkEndDate < now) {
            checkEndError = true
        }
        if (isError) {
            setError({ ...error, endEarly: true, endEarlyThanNow: checkEndError })
        } else {
            setError({ ...error, endEarly: false, endEarlyThanNow: checkEndError })
        }
        setState({ ...state, endDate: value })
    }

    const setStartDate = (value: Date) => {
        setState({ ...state, startDate: value })
    }

    const selectAll = () => {
        activeFilter("All")
        setState({ ...state, all: true, active: false, inactive: false })
    }

    const selectActive = () => {
        activeFilter("Active")
        setState({ ...state, all: false, active: true, inactive: false })
    }

    const selectInactive = () => {
        activeFilter("Inactive")
        setState({ ...state, all: false, active: false, inactive: true })
    }

    const toCategories = () => {
        redirect('categories')
    }

    return (
        <>
            <div className="dreamhome-main-title base-color">
                Prize Management
        </div>
            <div>

            </div>
            <div className="active-prizes-container">
                <div>
                    {title} management {isPrize && <img className="setting-prizes" onClick={toCategories} src={settings} alt="settings" />}
                </div>
                {path === "prizes" && <div>
                    <Box display="flex" alignItems="center">
                        <Box>
                            <Box display="flex">
                                <div className="prize-date">
                                    Start date
                            </div>
                                <div className="prize-date">
                                    {getDate(state.startDate)}
                                </div>
                            </Box>
                            <Box display="flex">
                                <div className="prize-date">
                                    Finish date
                            </div>
                                <div className="prize-date">
                                    {getDate(state.endDate)}
                                </div>
                            </Box>
                        </Box>
                        <Button className="countdown-button" onClick={showDialog}> Countdowns</Button>
                    </Box>
                    <Dialog
                        fullWidth
                        open={state.showDialog}
                        onClose={closeModal}
                        aria-label="Create post"
                        className="countdown-dialog"
                    >
                        <DialogContent>
                            <Box display="flex" alignItems="center" justifyContent="center" paddingTop="50px">
                                <Typography variant="h4" gutterBottom className="base-color">
                                    Countdowns
                                </Typography>
                            </Box>
                            <Box display="flex" alignItems="center" justifyContent="flex-start" marginTop="1em">
                                <Typography variant="h6" gutterBottom className="base-color">
                                    Start date
                        </Typography>

                                <form >
                                    <Box position="absolute">
                                        <DateTimePicker
                                            value={state.startDate}
                                            format={"dd-MM-y h:mm:ss a"}
                                            onChange={setStartDate}
                                            // disabled
                                            disableClock
                                            maxDate={new Date("2051-01-18T19:55:00.000+00:00")}
                                            minDate={new Date("2000-01-18T19:55:00.000+00:00")}
                                        />
                                        <Box marginTop="1em" >
                                            {!state.startDate && error.requiredStart && <div className="date-error">Required</div>}
                                        </Box>
                                    </Box>
                                </form>
                            </Box>

                            <Box display="flex" alignItems="center" justifyContent="flex-start" marginTop="2em">
                                <Typography variant="h6" gutterBottom className="base-color">
                                    Finish date
                        </Typography>
                                <form >
                                    <Box position="absolute">

                                        <DateTimePicker
                                            value={state.endDate}
                                            format={"dd-MM-y h:mm:ss a"}
                                            onChange={setEndDate}
                                            maxDate={new Date("2051-01-18T19:55:00.000+00:00")}
                                            minDate={new Date("2000-01-18T19:55:00.000+00:00")}
                                            disableClock
                                        />
                                        {error.endEarly && <div className=" date-error">Finish date cannot be earlier than Start date </div>}
                                        {error.endEarlyThanNow && <div className=" date-error"> Finish date cannot be earlier than now</div>}
                                        <Box marginTop="1em" >
                                            {!state.endDate && error.requiredEnd && <div className="date-error">Required</div>}
                                        </Box>
                                    </Box>
                                </form>
                            </Box>
                            <Box display="flex" alignItems="center" justifyContent="flex-start" marginTop="2em">
                                <div className="base-color">
                                    The next prize drawing will start
                                </div>
                            </Box>
                            <Box display="flex" alignItems="center" justifyContent="flex-start">
                                <div className="base-color">
                                    automatically for the same period
                                </div>
                            </Box>
                            <Box display="flex" alignItems="center" justifyContent="center" marginTop="2em">
                                <div className="base-color">
                                    <Button className="countdown-save-button" onClick={saveCountDown}>Save</Button>
                                </div>
                            </Box>
                        </DialogContent>
                    </Dialog>
                </div>}
                <div>
                    {
                        permission &&
                        <CreateButton className="add-button" label={`Add new ${title}`} to={`${path}/create`} />
                    }
                </div>
            </div>
            <div className='button-group'>
                <Button className={state.all ? "active-button" : "inactive-button"} onClick={selectAll}>All {title}</Button>
                <Button className={state.active ? "active-button" : "inactive-button"} onClick={selectActive}>Active {title}</Button>
                <Button className={state.inactive ? "active-button" : "inactive-button"} onClick={selectInactive}>Inactive {title}</Button>
            </div>
        </>
    )
}

export default PrizeListTitle